import api from '@/api'
import utils from '@/store/utils'

export default {
    state: {
        token: null,
        username: null,
        isTokenExpired: false,
        isAbbonamentoExpired: false,
        isFirstAccess: false,
        shouldChangePassword: false
    },
    mutations: {
        SET_TOKEN: (state, payload) => {
            state.token = payload
            api.instance.setTokenHeader(payload)
        },
        SET_USERNAME: utils.set('username'),
        SET_IS_TOKEN_EXPIRED: utils.set('isTokenExpired'),
        SET_IS_ABBONAMENTO_EXPIRED: utils.set('isAbbonamentoExpired'),
        SET_IS_FIRST_ACCESS: utils.set('isFirstAccess'),
        SET_SHOULD_CHANGE_PASSWORD: utils.set('shouldChangePassword')
    },
    actions: {
        login: async ({ commit }, { username, password }) => {
            let response = await api.auth.login(username, password)
            commit('SET_TOKEN', response.data.key)
            commit('SET_USERNAME', response.data.username)
            commit('SET_IS_ABBONAMENTO_EXPIRED', response.data.expired)
            commit('SET_IS_FIRST_ACCESS', response.data.primo_accesso)
            commit('SET_SHOULD_CHANGE_PASSWORD', response.data.change_password)
            return response
        },
        logout: ({ commit, dispatch }) => {
            commit('SET_TOKEN', null)
            commit('SET_USERNAME', null)
            commit('SET_IS_TOKEN_EXPIRED', false)
            commit('SET_IS_ABBONAMENTO_EXPIRED', false)
            commit('SET_IS_FIRST_ACCESS', false)
            commit('SET_SHOULD_CHANGE_PASSWORD', false)
            dispatch('reset')
        },
        cambioCentro: async ({ commit }, { username, schema }) => {
            let response = await api.auth.cambioCentro(username, schema)

            commit('SET_TOKEN', response.data.key)
            commit('SET_IS_ABBONAMENTO_EXPIRED', response.data.expired)
            commit('SET_IS_FIRST_ACCESS', response.data.primo_accesso)
            commit('SET_SHOULD_CHANGE_PASSWORD', response.data.change_password)
            return response
        },
    },
    getters: {
        isLoggedIn: state => !!state.token,
        isFirstAccess: state => state.isFirstAccess,
        isAbbonamentoExpired: state => state.isAbbonamentoExpired,
        getUsername: state => state.username
    }
}
